module.exports = __webpack_public_path__ + "static/img/6.de89bed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/zh/6.png
// module id = zMYK
// module chunks = 0